import { Result, Typography } from "antd";
import { ApiService } from "api/api.service";
import { SingleQueryWrapper } from "components/QueryWrapper";
import { TbAlertCircleFilled } from "react-icons/tb";
// import { useParams } from "react-router-dom";
import { storedTokens } from "utils/storedTokens";

const ViewDocs = () => {
  // const params = useParams();
  // const fileId = params?.fileId as string;
  const fileUrl = storedTokens.fileViewer.getToken();

  const file = ApiService.file.useGetExternalUrl(fileUrl);
  if (!fileUrl) {
    return (
      <div className="flex items-center justify-center p-5 max-w-[700px] mx-auto">
        <Result
          icon={<TbAlertCircleFilled size={72} className={`mx-auto text-red-500`} />}
          status={"error"}
          title={<Typography.Title className="!mb-3 font-extrabold">404</Typography.Title>}
          subTitle={"Invalid link or file not found"}
          // extra={errorExtra?.(query.error)}
        />
      </div>
    );
  }
  return (
    <div>
      <SingleQueryWrapper
        query={file}
        renderData={() => {
          return (
            <iframe
              src={fileUrl}
              onLoad={() => {
                storedTokens.fileViewer.removeToken();
              }}
              style={{ width: "100%", minHeight: "100vh", border: "none" }}
            />
          );
        }}
      />
    </div>
  );
};

export default ViewDocs;
